import styled from 'styled-components';
import { SparkType } from '../../redux/models/colyseumSchemas/Spark';
import { getSparkImage } from '../../utils/sparks';

const Img = styled('img')`
  width: 100%;
  max-height: 180px;
`;

export type SparkImgProps = {
  sparkType: SparkType;
};

export const SparkImg = ({ sparkType }: SparkImgProps) => (
  <Img alt={`${sparkType} card`} src={getSparkImage(sparkType)} />
);
